import { useState } from 'react';

export interface TokenCounterProps {
  image: string;
  max?: number;
}

export function TokenCounter({ image, max = 100 }: TokenCounterProps) {
  const [count, setCount] = useState(0);

  const countUp = (ctrl: boolean) => {
    setCount((prev) => Math.min(prev + (ctrl ? 10 : 1), max));
  };

  const countDown = (ctrl: boolean) => {
    setCount((prev) => Math.max(prev - (ctrl ? 10 : 1), 0));
  };

  return (
    <div
      className="relative w-8 h-8 cursor-pointer select-none"
      onClick={(e) => countUp(e.ctrlKey)}
      onContextMenu={(e) => { e.preventDefault(); countDown(e.ctrlKey); }}
    >
      <span className="absolute inset-0 flex items-center justify-center text-lg font-bold z-10
        [text-shadow:1px_1px_2px_black,0_0_8px_rgba(0,0,255,0.6)]">
        {count}
      </span>
      <img src={image} alt="Tokens" className="w-8 h-8" />
    </div>
  );
}
